import "./Cancel.scss";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useI18N } from "i18n";
import Layout from "pages/Landing/Layout/Layout";

const Cancel = () => {
  const navigate = useNavigate();
  const { I18N } = useI18N();

  const navigationTimeout = 1500;

  useEffect(() => {
    setTimeout(() => {
      navigate("/profile");
    }, navigationTimeout);
  }, []);

  return (
    <Layout>
      <div className="cancel-page">
        <div className="cancel_wrapper">
          <h1>
            <I18N id={"payment_cancelled_header"} />
          </h1>
          <p>
            <I18N id={"payment_cancelled_text"} />
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Cancel;
